import { Box, Flex, Text } from '@chakra-ui/react';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';
import SubmissionInfoWithAuthors from '../ReviewTab/SubmissionInfoWithAuthors';
import { ReactNode } from 'react';
import NavbarDashboard from 'src/components/NavbarDashboard';
import SingleItem from 'src/layouts/SingleItem';
import { COCSubmissionAssignment } from 'src/pages/SubmissionDetails/COCSubmissionAssignment';
import { useSubmissionData } from 'src/contexts/SubmissionDataProvider';
interface DecisionLayoutProps {
  children: ReactNode;
  sidebar?: ReactNode;
  onClose?: () => void;
  manuscriptId?: string;
}

const DecisionLayout: React.FC<DecisionLayoutProps> = ({
  children,
  sidebar,
  onClose,
  manuscriptId
}) => {
  const { submissionId } = useSubmissionData();
  return (
    <>
      <NavbarDashboard />
      <SingleItem bgColor="surfacePrimaryFill">
        <SingleItem.MainArea>
          <SingleItem.Header>
            <Box paddingTop={4} paddingX={3} bgColor="surfacePrimaryFill">
              <Flex>
                <Box borderRight={'1px solid'} px={3} borderColor="gray.200">
                  <ButtonText onClick={onClose}>
                    <FontAwesomeIcon icon={faArrowLeft} size="lg" /> Back
                  </ButtonText>
                </Box>
                <Text
                  as="span"
                  pl={4}
                  textStyle={'headingItem'}
                  fontWeight="semibold"
                >
                  # {manuscriptId}
                </Text>
              </Flex>
              <SubmissionInfoWithAuthors
                isManuscriptId={false}
              />
            </Box>
          </SingleItem.Header>
          <SingleItem.Content size="default" bgColor="surfacePrimaryFill">
            {children}
          </SingleItem.Content>
        </SingleItem.MainArea>

        <SingleItem.Sidebar>
          <Flex flexDirection="column" gap={4} padding={3} width="100%">
            <COCSubmissionAssignment submissionId={submissionId} readOnly />
            {sidebar}
          </Flex>
        </SingleItem.Sidebar>
      </SingleItem>
    </>
  );
};

export default DecisionLayout;
